<template>
	<div class="wrap">
		<div class="main">
			<div class="itopbox">
				<div class="itopli">
					<div class="litop">
						<img src="../../assets/image/Web.png" class="liead" alt="">
						<div class="litxt">
							欢迎，{{info.username}}
						</div>
					</div>
					<div class="litop">
						<div class="quantxt">安全等级：</div>
						<el-progress style="flex-grow: 1;"  :percentage="50" :stroke-width="15"  :format="format"></el-progress>
					</div>
					<div class="litop">
						<div class="quantxt">用户级别：</div>
						<div class="jibie">普通用户</div>
					</div>
					<div class="zhanbox">
						<div class="zhanli" @click="$router.push('/home/member')">会员信息</div>
						<div class="zhanli" @click="$router.push('/home/comprehensive')">订单管理</div>
						<div class="zhanli" @click="$router.push('/home/member')" v-if="info.isCertify">已实名</div>
						<div class="zhanli" @click="$router.push('/home/member')" v-else>未实名</div>
					</div>
				</div>
				<div class="itopli">
					<div class="keyu">
						可用余额
					</div>
					<div class="yuenum">{{info.money}}<span>元</span></div>
					<div class="qiebox">
						<div class="qieboxli"  v-for="(item , index) in qieList" :class="{'qieactive':isActive == index}" @mousemove="qihuan(index)" @click="goTopage(item.path)">
							{{item.title}}
						</div>
					</div>
				</div>
				<div class="itopli">
					<div class="lianbox" style="padding-bottom: 52px;">
						<img src="../../assets/image/Web.png" class="liead" alt="">
						<div class="lianxi">
							<div class="lianxitxt">
								售前经理：<span>{{info.kefu.real_name}}</span>
							</div>
							<div class="lianxitxt">
								联系电话：<span>{{info.kefu.phone}}</span>
							</div>
							<div class="lianxitxt">
								QQ：<span>{{info.kefu.qq}}</span>
							</div>
						</div>
					</div>
					<div class="lianbox">
						<img src="../../assets/image/Web.png" class="liead" alt="">
						<div class="lianxi">
							<div class="lianxitxt">
								售后工程师：<span>张东方</span>
							</div>
							<div class="lianxitxt">
								联系电话：<span>18137332180</span>
							</div>
							<div class="lianxitxt">
								QQ：<span>97975622</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="kenengbox">
				<div class="ketitle">您可能还需要以下产品</div>
				<div class="kexuan">
					<div class="keli">
						<p>企业建站</p>
						<p>云端智能建站、快速高效</p>
						<div class="xauntxt">立即选购</div>
					</div>
					<div class="keli">
						<p>小程序</p>
						<p>拥有丰富开发经验和强大的工程师团队，确保小程序如期完成，安全高效运营</p>
						<div class="xauntxt">立即选购</div>
					</div>
					<div class="keli">
						<p>资质办理</p>
						<p>ICP\ISP\IDC\EDI全网资质办理服务，多年办理经营，政策全掌握</p>
						<div class="xauntxt">立即选购</div>
					</div>
					<div class="keli">
						<p>网站加速防护</p>
						<p>CND加速、抗攻击服务ADS、安全监测WS、应用防火墙WAF一站解决</p>
						<div class="xauntxt">立即选购</div>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template> 

<script>
export default {
    data () {
        return {
			qieList:[
				{
					title:'立即充值',
					path:'/home/recharge'
				},
				{
					title:'财务信息',
					path:'/home/finance'
				},
				{
					title:'业务管理',
					path:'/home/comprehensive'
				},
				{
					title:'发票申请',
					path:'/home/invoice'
				}
			],
			isActive:0,
			info:{}
        }
    },
    created () {
		this.getIndexData()
		if(!localStorage.getItem('token')){
			window.location.href = 'https://www.idckw.com/site/login'
		}
		 
    }, 
    methods: {
		  async getIndexData() {
		        const res = await this.$api.getIndexData();
				console.log(res,'首页数据')
				this.info = res.data
		    },

         format(percentage) {
			return percentage > 80 ? '高' : `中`;
		  },
		  qihuan(index){
			  this.isActive = index
		  },
		  goTopage(path){
			  console.log(path)
			  this.$router.push({
			  	path: path
			  });
		  }
    },
    
}
</script>

<style >
	.itopbox{
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 20px;
	}
	.itopli{
		width: 30%;
		background-color: #ffffff;
		border-radius: 10px;
		height: 200px;
		padding: 20px;
	}
	.litop{
		display: flex;
		align-items: center;
		padding-bottom: 13px;
	}
	.liead{
		display: inline-block;
		width: 50px;
		border-radius: 50%;
		border: 3px solid #ccc;
	}
	.litxt{
		font-size: 14px;
		color: #333333;
		padding-left: 30px;
	}
	.quantxt{
		font-size: 14px;
		color: #333333;
		padding-right: 10px;
	}
	.jibie{
		font-size: 14px;
		color: #ffaa00;
	}
	.zhanbox{
		display: flex;
		align-items: center;
		justify-content: space-between;
		border: 1px solid #cccccc;
		height: 60px;
	}
	.zhanli{
		width: 33%;
		height: 100%;
		text-align: center;
		line-height: 60px;
		font-size: 14px;
		cursor: pointer;
		border-right: 1px solid #cccccc;
	}
	.zhanli:last-child{
		border: none;
	}
	.zhanli:hover{
		color: #FF8900;
	}
	.keyu{
		color: #8E9297;
		font-size: 12px;
		font-weight: 700;
		padding-bottom: 30px;
	}
	.yuenum{
		font-size: 45px;
		color: #000;
		padding-bottom: 35px;
		font-weight: bold;
	}
	.yuenum span{
		font-size: 24px;
		font-weight: 500;
		color: #000;
	}
	.qiebox{
		display: flex;
		align-items: center;
	}
	.qieboxli{
		width: 100px;
		height: 40px;
		border-radius: 4px;
		background-color: #ffffff;
		cursor: pointer;
		font-size: 14px;
		color: #333333;
		text-align: center;
		line-height: 40px;
	}
	.qieactive{
		background-color: #FF8900;
		color: #ffffff;
	}
	.lianbox{
		display: flex;
		align-items: flex-start;
	}
	.lianxi{
		padding-left: 25px;
	}
	.lianxitxt{
		padding: 3px 0;
		font-size: 14px;
		color: #333333;
	}
	.lianxitxt span{
		color: #888888;
		font-size: 14px;
	}
	.kenengbox{
		background-color: #ffffff;
		border-radius: 10px;
		padding: 30px 20px;
	}
	.ketitle{
		font-size: 16px;
		color: #8E9297;
		font-weight: bold;
		padding-bottom: 20px;
	}
	.kexuan{
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.keli{
		width: 25%;
		border-right: 1px solid #eeeeee;
		flex-shrink: 0;
	}
	.keli:last-child{
		border-right: none;
	}
	.keli p{
		font-size: 14px;
		color: #333333;
		padding: 0 30px 10px;
	}
	.xauntxt{
		font-size: 14px;
		color: #FF8900;
		cursor: pointer;
		padding: 0 30px ;
	}
</style>
